"use client";

import { c as _c } from "react/compiler-runtime";
import { Col } from "react-bootstrap";
import styles from "../NFTImage.module.scss";
import NFTImageBalance from "../NFTImageBalance";
import type { BaseRendererProps } from "../types/renderer-props";
function getSrc(nft: BaseRendererProps["nft"]): string | undefined {
  const hasMetadata = "metadata" in nft;
  const hasAnimation = hasMetadata && nft.metadata.animation;
  if (hasAnimation) {
    return nft.metadata.animation;
  } else if (hasMetadata) {
    return nft.metadata.animation_url;
  }
  return undefined;
}
export default function NFTHTMLRenderer(props) {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.nft) {
    t0 = getSrc(props.nft);
    $[0] = props.nft;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const src = t0;
  const t1 = `${styles.nftAnimation} ${props.heightStyle} ${props.imageStyle} ${props.bgStyle} d-flex justify-content-center align-items-center`;
  let t2;
  if ($[2] !== props.height || $[3] !== props.nft || $[4] !== props.showBalance) {
    t2 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[2] = props.height;
    $[3] = props.nft;
    $[4] = props.showBalance;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = props.id ?? `iframe-${props.nft.id}`;
  let t4;
  if ($[6] !== props.id || $[7] !== src || $[8] !== t3) {
    t4 = <iframe title={props.id} src={src} id={t3} />;
    $[6] = props.id;
    $[7] = src;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <Col className={t1}>{t2}{t4}</Col>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}